<template lang="pug">
  .text-center.neutral700--text
    v-icon.mb-5(size="55" color="success500") $yzi-gift-02
    template(v-if="member && redeemedReward")
      .text-md.font-semibold.mb-4 {{ member.name }} has redeemed 1 reward!
      y-chip.round-xl.pa-4.bg-color.d-block.mb-4
        .d-flex
          v-icon(color="success500") $yzi-gift-02
          .text-left.ml-3
            .text-sm 1 reward redeemed:
            ul
              li.text-sm {{ redeemedReward.name }}
      y-chip.round-xl.d-block.pa-4(outlined)
        v-row.align-center.mb-2(no-gutters)
          v-col(cols="4")
            .text-sm.text-left Customer:
          v-col
            .text-sm.text-left.font-semibold {{ member.name }}
        v-row.align-center(no-gutters)
          v-col(cols="4")
            .text-sm.text-left Phone number:
          v-col
            .text-sm.text-left.font-semibold +{{ member.phone }}
      v-card.pa-4.round-xl.mt-4(outlined)
        .d-flex.align-center.justify-space-between
          .d-flex.align-center
            v-icon(size="15" color="neutral700") $yzi-link-01
            .text-sm.text-left.ml-2 Share link to customer’s loyalty profile. Link is unique.
          .text-sm.underline.font-semibold.cursor-pointer.hover-bg(@click="copyLink(member)") Copy link
      div(ref="copy")
    template(v-else)
      v-skeleton-loader(type="list-item-two-line@3")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    // customer: {
    //   type: Object,
    //   required: true,
    // },
    redeemedReward: {
      type: Object,
      default: null,
    },
    member: {
      type: Object,
      required: true
    },
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
  },
  methods: {
    ...mapActions(['showMessage']),
    getLoyaltyLink (member) {
      return `https://${this.company.slug}.yezza.co/loyalty/${member.pid}`
    },
    copyLink (member) {
      let url = this.getLoyaltyLink(member)
      let container = this.$refs.copy
      this.$copyText(url, container)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
        })
    },
  }
}
</script>

<style scoped>
.bg-color {
  background-color: #E9FFE6 !important
}
</style>